import { CalendarScheduleIcon } from 'src/assets/icons/CalendarScheduleIcon';
import { EditIcon } from 'src/assets/icons/EditIcon';
import { ListIcon } from 'src/assets/icons/ListIcon';
import {
  REPORTS_ASSET_PATH,
  REPORTS_BUILD_PREFIX,
  REPORTS_DATA_PATH,
  REPORTS_HISTORY,
  REPORTS_PDF_PATH,
  REPORTS_PDF_SITE_STATUS_PATH,
  REPORTS_SCHEDULE,
} from 'src/routes/config';

export const ASSET_REPORT_NAV_ITEMS = [
  {
    title: 'History',
    icon: ListIcon,
    url: `${REPORTS_BUILD_PREFIX}/${REPORTS_HISTORY}`,
  },
  {
    title: 'Editor',
    icon: EditIcon,
    url: `${REPORTS_BUILD_PREFIX}/${REPORTS_ASSET_PATH}`,
  },
  {
    title: 'Schedule',
    icon: CalendarScheduleIcon,
    url: `${REPORTS_BUILD_PREFIX}/${REPORTS_SCHEDULE}`,
  },
];
export const DATA_REPORT_NAV_ITEMS = [
  {
    title: 'History',
    icon: ListIcon,
    url: `${REPORTS_BUILD_PREFIX}/${REPORTS_HISTORY}`,
  },
  {
    title: 'Editor',
    icon: EditIcon,
    url: `${REPORTS_BUILD_PREFIX}/${REPORTS_DATA_PATH}`,
  },
  {
    title: 'Schedule',
    icon: CalendarScheduleIcon,
    url: `${REPORTS_BUILD_PREFIX}/${REPORTS_SCHEDULE}`,
  },
];
export const PDF_REPORT_NAV_ITEMS = [
  {
    title: 'History',
    icon: ListIcon,
    url: `${REPORTS_BUILD_PREFIX}/${REPORTS_HISTORY}`,
  },
  {
    title: 'Editor',
    icon: EditIcon,
    url: `${REPORTS_BUILD_PREFIX}/${REPORTS_PDF_PATH}`,
  },
  {
    title: 'Schedule',
    icon: CalendarScheduleIcon,
    url: `${REPORTS_BUILD_PREFIX}/${REPORTS_SCHEDULE}`,
  },
];
export const PDF_SITE_STATUS_REPORT_NAV_ITEMS = [
  {
    title: 'History',
    icon: ListIcon,
    url: `${REPORTS_BUILD_PREFIX}/${REPORTS_HISTORY}`,
  },
  {
    title: 'Editor',
    icon: EditIcon,
    url: `${REPORTS_BUILD_PREFIX}/${REPORTS_PDF_SITE_STATUS_PATH}`,
  },
  {
    title: 'Schedule',
    icon: CalendarScheduleIcon,
    url: `${REPORTS_BUILD_PREFIX}/${REPORTS_SCHEDULE}`,
  },
];
